import { render, staticRenderFns } from "./UserScreen.vue?vue&type=template&id=6f2d0026&scoped=true"
import script from "./UserScreen.vue?vue&type=script&lang=js"
export * from "./UserScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d0026",
  null
  
)

export default component.exports